import { makeObservable } from 'mobx';

import StoreSelectionState, { LanguageItem, StoreWithUniqueKey } from '../../../../app/layout/StoreSelectionState';
import { StoreAndLanguageSelectorComponentTranslation } from '../../../../app/localization/SiteTranslation';

class StoreAndLanguageSelectorState {
  public readonly currentStoreLanguages: LanguageItem[];

  public get currentLanguage() {
    return this.storeSelection.currentLanguage;
  }

  public get currentStore() {
    return this.storeSelection.currentStore;
  }

  public get isCurrentStoreMultilingual() {
    return this.currentStoreLanguages.length > 1;
  }

  public get stores() {
    return this.storeSelection.stores;
  }

  public constructor(
    public readonly storeSelection: StoreSelectionState,
    public readonly translation: StoreAndLanguageSelectorComponentTranslation,
  ) {
    makeObservable(this);

    this.currentStoreLanguages = this.getLanguagesByStore(this.currentStore);
  }

  public getLanguagesByStore(store: StoreWithUniqueKey) {
    return this.storeSelection.getLanguages(store.key);
  }

  public isLanguageCurrent(language: LanguageItem) {
    return language.code === this.currentLanguage.code;
  }

  public isStoreCurrent(store: StoreWithUniqueKey) {
    return store.key === this.currentStore.key;
  }

  public select = (store: StoreWithUniqueKey, language: LanguageItem) => {
    this.storeSelection.selectStore(store.key, language.code);
  };

  public selectLanguage = (language: LanguageItem) => {
    if (this.isLanguageCurrent(language)) {
      return;
    }

    this.storeSelection.selectStore(this.currentStore.key, language.code);
  };

  public selectStore = (store: StoreWithUniqueKey) => {
    const isCurrentLanguageSupported = store.languages.some((l) => l.code === this.currentLanguage.code);
    const languageCode = isCurrentLanguageSupported ? this.currentLanguage.code : store.languages.first().code;

    if (this.isStoreCurrent(store) && languageCode === this.currentLanguage.code) {
      return;
    }

    this.storeSelection.selectStore(store.key, languageCode);
  };
}

export default StoreAndLanguageSelectorState;
